import "./component.tag"

export default {
    title: "Basic Usage",
    editLink: "https://github.com/elbywan/bosket/edit/master/docs/riot/plan/treeview/basic%20usage/index.js",
    content: "basic-usage"
}



// WEBPACK FOOTER //
// ./docs/riot/plan/treeview/basic usage/index.js